import { html } from "lit-html";

export default html`<svg
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class="loader-svg"
>
	<path
		d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37259 5.37258 5.72204e-06 12 5.72204e-06C18.6274 5.72204e-06 24 5.37259 24 12ZM3.15853 12C3.15853 16.883 7.11699 20.8415 12 20.8415C16.883 20.8415 20.8415 16.883 20.8415 12C20.8415 7.117 16.883 3.15854 12 3.15854C7.11699 3.15854 3.15853 7.117 3.15853 12Z"
		fill="var(--color-icon-default)"
	></path>
	<path
		class="loader-fill"
		d="M19.7392 2.82916C18.0239 1.38162 15.937 0.444167 13.7156 0.123279C11.4942 -0.197609 9.22734 0.110935 7.17251 1.01386C5.11768 1.91679 3.35726 3.3779 2.09124 5.23122C0.825214 7.08454 0.104336 9.25577 0.0104934 11.4983L3.28474 11.6353C3.35296 10.0052 3.87697 8.42692 4.79725 7.07973C5.71753 5.73254 6.99719 4.67044 8.49086 4.0141C9.98453 3.35776 11.6323 3.13347 13.2471 3.36673C14.8619 3.59998 16.3788 4.28143 17.6257 5.33365L19.7392 2.82916Z"
		fill="var(--color-primary-default)"
	></path>
</svg>`.strings.join("");
